import { $el } from './elements';
import { UISVG, $svg } from './svg';
import { onTouch, uiTouchIn, UITouchDelegate, UITouchEvent } from './touch';
import { UIViewSpec } from './view';

function doRipple(event: UITouchEvent): false | UITouchDelegate {
    const elem = event.elem;
    if(elem.classList.contains('f-disabled')) return false;

    const rect = elem.getBoundingClientRect();
    const point = uiTouchIn(event.touch, elem);

    const ripple = new UISVG('ui-ripple', [rect.width, rect.height]);
    ripple.ui_elem.style.borderRadius = getComputedStyle(elem).borderRadius;
    const dx = Math.max(rect.width - point[0], point[0]);
    const dy = Math.max(rect.height - point[1], point[1]);
    const s = Math.sqrt(dx * dx + dy * dy);

    const circle = $svg.CIRCLE(point[0], point[1], s);
    circle.style.transformOrigin = point[0] + 'px ' + point[1] + 'px';
    ripple.add(circle);

    elem.ui_prepend(ripple);

    return {
        touchEnd: () => {
            ripple.classList.add('f-gone');
            setTimeout(() => { ripple.remove() }, 300);
        }
    };
}

function doFixedRipple(event: UITouchEvent): false | UITouchDelegate {
    const elem = event.elem;
    if(elem.classList.contains('f-disabled')) return false;

    const ripple = $el.DIV('ui-fixed-ripple');

    elem.ui_prepend(ripple);

    return {
        touchEnd: () => {
            ripple.classList.add('f-gone');
            setTimeout(() => { elem.removeChild(ripple) }, 300);
        }
    };
}

interface UIRippleOptions {
    fixed?: boolean;
}

export function uiAddRipple(where: UIViewSpec, options: UIRippleOptions = {}) {
    const elem = where.ui_elem;

    if(options.fixed) {
        onTouch(elem, doFixedRipple);
    } else {
        onTouch(elem, doRipple);
    }
}